export const DOWNLOAD_RESULTS_PDF_FILE_REQUEST = 'DOWNLOAD_RESULTS_PDF_FILE_REQUEST';

export const downloadResultsPdfFileRequest = ({ module, year }) => ({
    type: DOWNLOAD_RESULTS_PDF_FILE_REQUEST,
    payload: { module, year }
});
